import { Colors } from '@/common/colors/colors';
import SelectInput from '@/common/components/SelectInput';
import { useState } from 'react';
import { PlaceholderLabel, SelectPlaceholder } from './LazySelectInput.styles';

const LazySelectInput = ({
	options,
	selected,
	setSelected,
	ariaLabel,
	placeholder = 'Select...',
	selectWidth = 180,
	selectFontSize = 12,
	minHeight = '32px',
}) => {
	const [isEditing, setIsEditing] = useState(false);

	const handleSelect = (option) => {
		setSelected(option);
		setIsEditing(false);
	};

	if (!isEditing) {
		return (
			<SelectPlaceholder
				role='button'
				tabIndex={0}
				aria-label={ariaLabel}
				onClick={() => setIsEditing(true)}
				onFocus={() => setIsEditing(true)}
				$width={selectWidth}
				$minHeight={minHeight}
				$fontSize={selectFontSize}
			>
				<PlaceholderLabel>{selected?.label || placeholder}</PlaceholderLabel>
				<i className='bi bi-chevron-down' />
			</SelectPlaceholder>
		);
	}

	return (
		<SelectInput
			showLabel={false}
			color={Colors.darkBlue}
			options={options}
			selected={selected}
			setSelected={handleSelect}
			placeholder={placeholder}
			selectWidth={selectWidth}
			selectFontSize={selectFontSize}
			minHeight={minHeight}
			margin='0'
			autoFocus
			defaultMenuIsOpen
			onBlur={() => setIsEditing(false)}
		/>
	);
};

export default LazySelectInput;
